// Petits utilitaires de dates/durées partagés par toutes les pages. Les
// dates de cours sont manipulées en chaînes locales "AAAA-MM-JJ" et les
// heures en "HH:MM" (jamais en Date UTC) pour éviter tout décalage de fuseau.

export const MOIS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
export const JOURS_COURTS = ["lun.", "mar.", "mer.", "jeu.", "ven.", "sam.", "dim."];
export const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];

const pad = (n) => String(n).padStart(2, "0");

export function toISODate(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function todayISO() {
  return toISODate(new Date());
}

export function parseISODate(s) {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(iso, n) {
  const d = parseISODate(iso);
  d.setDate(d.getDate() + n);
  return toISODate(d);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

export function fmtDateLong(iso) {
  if (!iso) return "";
  const d = parseISODate(iso);
  return `${JOURS[d.getDay()]} ${d.getDate()} ${MOIS[d.getMonth()]} ${d.getFullYear()}`;
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function fmtDuration(minutes) {
  if (!minutes && minutes !== 0) return "—";
  const m = Number(minutes);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  const r = m % 60;
  return r ? `${h} h ${pad(r)}` : `${h} h`;
}

export function timeToMinutes(hhmm) {
  const [h, m] = (hhmm || "0:0").split(":").map(Number);
  return h * 60 + m;
}

export function minutesToTime(total) {
  const t = Math.max(0, Math.min(23 * 60 + 59, Math.round(total)));
  return `${pad(Math.floor(t / 60))}:${pad(t % 60)}`;
}

export function addMinutesToTime(hhmm, minutes) {
  return minutesToTime(timeToMinutes(hhmm) + Number(minutes || 0));
}

export function age(iso) {
  if (!iso) return null;
  const b = parseISODate(iso.slice(0, 10));
  const n = new Date();
  let a = n.getFullYear() - b.getFullYear();
  if (n.getMonth() < b.getMonth() || (n.getMonth() === b.getMonth() && n.getDate() < b.getDate())) a -= 1;
  return a;
}

// Grille du mois (semaines commençant le lundi), 6 lignes max.
export function monthGrid(year, month) {
  const first = new Date(year, month, 1);
  const offset = (first.getDay() + 6) % 7;
  const start = new Date(year, month, 1 - offset);
  const days = [];
  for (let i = 0; i < 42; i += 1) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push({ iso: toISODate(d), day: d.getDate(), inMonth: d.getMonth() === month });
  }
  // Retire la dernière semaine si elle est entièrement hors du mois.
  if (!days.slice(35).some((d) => d.inMonth)) return days.slice(0, 35);
  return days;
}

export function sessionStatus(dateIso) {
  const t = todayISO();
  if (dateIso < t) return "passe";
  if (dateIso === t) return "aujourdhui";
  return "futur";
}

export function initials(prenom, nom) {
  return `${(prenom || "").charAt(0)}${(nom || "").charAt(0)}`.toUpperCase();
}
